export const suggestionKeys = {
  all: () => ["suggestions"] as const,
  list: (
    filters: Partial<{
      lat: string;
      lng: string;
      apiKey: string;
    }>
  ) => [...suggestionKeys.all(), filters] as const,
};
